export default __webpack_public_path__ + "static/rzut-domku-z-gory-17c623691046468ad4072d6673043eea.jpeg";